import { ChevronRight } from 'lucide-react'

interface MobileMenuItemProps {
    label: string
    description?: string
    icon?: React.ComponentType<{ className?: string }>
    hasSubmenu?: boolean
    isSubmenuItem?: boolean
    showChevron?: boolean
    onClick?: () => void
    className?: string
    iconClassName?: string
    labelClassName?: string
}

export function MobileMenuItem({
    label,
    description,
    icon: Icon,
    hasSubmenu,
    isSubmenuItem,
    showChevron = true,
    onClick,
    className = '',
    iconClassName = 'text-gray-100',
    labelClassName = 'text-gray-100'
}: MobileMenuItemProps) {
    return (
        <button
            onClick={onClick}
            className={`w-full flex items-center justify-between text-left hover:bg-gray-100 dark:hover:bg-zinc-900 transition-colors rounded-xl mx-2 my-1 w-[calc(100%-16px)] ${isSubmenuItem
                ? 'px-4 py-3 pl-12' // Submenu items
                : 'px-4 py-3'  // Main items
                } ${className}`}
        >
            <div className="flex items-center gap-4">
                {Icon && <Icon className={`w-6 h-6 shrink-0 ${iconClassName}`} />}
                <div className="flex flex-col">
                    <span className={`text-[15px] font-semibold ${isSubmenuItem ? 'text-sm' : ''} ${labelClassName}`}>{label}</span>
                    {description && (
                        <span className="text-xs text-gray-500 dark:text-zinc-500 font-medium mt-0.5">{description}</span>
                    )}
                </div>
            </div>
            {(hasSubmenu || showChevron) && <ChevronRight className="w-5 h-5 text-gray-400 dark:text-zinc-600" />}
        </button>
    )
}
